import type { CustomizationField, CustomizationFieldInput } from '../api/business/types';

/** The API's limit of customization fields per product (R0030 WP-11). */
export const MAX_CUSTOMIZATION_FIELDS = 20;

/** The product's fields as a write keeps them: each by its id, in order, its labels left as they are. */
export const keptFields = (fields: Array<CustomizationField>): Array<CustomizationFieldInput> =>
  fields.map((field) => ({ id: field.id, type: field.type, required: field.required, labels: {} }));

/** `fields` with the one at `index` replaced by `field` — or `field` added at the end when `index` is null. */
export const withField = (
  fields: Array<CustomizationFieldInput>,
  index: number | null,
  field: CustomizationFieldInput,
): Array<CustomizationFieldInput> =>
  index === null ? [...fields, field] : fields.map((one, position) => (position === index ? field : one));

/** `fields` without the one at `index`. */
export const withoutField = (
  fields: Array<CustomizationFieldInput>,
  index: number,
): Array<CustomizationFieldInput> => fields.filter((_one, position) => position !== index);

/** `fields` with the one at `index` moved by `step`; unchanged at either end. */
export const movedField = (
  fields: Array<CustomizationFieldInput>,
  index: number,
  step: -1 | 1,
): Array<CustomizationFieldInput> => {
  const target = index + step;

  if (index < 0 || index >= fields.length || target < 0 || target >= fields.length) {
    return fields;
  }

  const moved = [...fields];

  [moved[index], moved[target]] = [moved[target], moved[index]];

  return moved;
};
